import { render, staticRenderFns } from "./HomeCarousel.vue?vue&type=template&id=55d89ae4"
import script from "./HomeCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports